module.exports = __webpack_public_path__ + "61eb7d54c78f56d831c993845b46f403.svg";